import React from "react";

const Bar = ({ className = "" }) => (
  <div className={`animate-pulse rounded bg-cloud-mist ${className}`} />
);

/** Placeholder card with the same geometry as NewsletterCard. */
const NewsletterCardSkeleton = () => (
  <div
    aria-hidden="true"
    className="rounded-xl border border-hairline bg-surface-white p-6 sm:p-8"
  >
    <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-12">
      <div className="flex flex-col items-start gap-3 lg:col-span-8">
        <div className="flex items-center gap-2.5">
          <Bar className="h-7 w-40 rounded-md" />
          <Bar className="h-4 w-24" />
        </div>
        <Bar className="h-5 w-44" />
        <div className="flex w-full flex-col gap-2">
          <Bar className="h-7 w-full" />
          <Bar className="h-7 w-3/5" />
        </div>
        <div className="flex w-full flex-col gap-2 pt-2">
          <Bar className="h-4 w-full" />
          <Bar className="h-4 w-full" />
          <Bar className="h-4 w-4/5" />
        </div>
        <Bar className="mt-4 h-11 w-56 rounded-xl" />
      </div>
      <div className="flex justify-center lg:col-span-4 lg:justify-end">
        <Bar className="aspect-[3/4] w-full max-w-[280px] rounded-xl" />
      </div>
    </div>
  </div>
);

const NewsletterSkeleton = ({ count = 3 }) => (
  <div aria-busy="true" className="flex flex-col gap-8 md:gap-10">
    <p className="sr-only">Loading newsletters…</p>
    {Array.from({ length: count }, (_, i) => (
      <NewsletterCardSkeleton key={i} />
    ))}
  </div>
);

export default NewsletterSkeleton;
